import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { UpdateCompanyBody, CompanyResponse, updateCompany, CreateCompanyBody, createCompany } from '../../services/apiSLTP/materials/companies';

type UseUpdateCompanyMutationOptions = MutationOptions<CompanyResponse, Error, { companyId: string; data: UpdateCompanyBody }>;
type UseCreateCompanyMutationOptions = MutationOptions<CompanyResponse, Error, CreateCompanyBody>;

export const useUpdateCompanyMutation = (options?: UseUpdateCompanyMutationOptions) => {
    const mutationFn: MutationFunction<CompanyResponse, { companyId: string; data: UpdateCompanyBody }> = async ({ companyId, data }) => {
        try {
            const response: CompanyResponse = await updateCompany(companyId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during company update');
        }
    };

    return useMutation(mutationFn, options);
};

export const useCreateCompanyMutation = (options?: UseCreateCompanyMutationOptions) => {
    const mutationFn: MutationFunction<CompanyResponse, CreateCompanyBody> = async (data) => {
        try {
            const response: CompanyResponse = await createCompany(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during company creation');
        }
    };

    return useMutation(mutationFn, options);
};
